/* BELLER: wspólny moduł filtrów (wyszukiwanie + kolekcje).
   Drawer, akordeony z animacją, AJAX-owe odświeżanie wyników bez zamykania panelu, scroll-lock. */
(function () {
  if (window.__bmsFacetsModule) return;
  window.__bmsFacetsModule = 1;

  function scopeEl() { return document.querySelector('.bms-search-facets'); }
  function isSearchPage() { return !!document.querySelector('.bms-search-layout'); }

  /* --- przełącznik panelu --- */
  window.bmsToggleFilters = function () {
    var drawerMode = !isSearchPage() || window.matchMedia('(max-width: 900px)').matches;
    if (drawerMode) {
      document.body.classList.toggle('bms-facets-open');
      setTimeout(function () { window.bmsAlignFacetsClose && window.bmsAlignFacetsClose(); }, 380);
    } else {
      document.body.classList.toggle('bms-filters-collapsed');
    }
  };

  /* „X" drawera: pion = oś ikony koszyka, poziom = oś kolumny ikon +/− */
  window.bmsAlignFacetsClose = function () {
    var x = document.querySelector('.bms-facets-close');
    var drawer = scopeEl();
    if (!x || !drawer) return;
    var cart = document.querySelector('.icon-cart-bag');
    var pm = document.querySelector('.bms-search-facets .icon-closed');
    if (cart) { var cr = cart.getBoundingClientRect(); if (cr.height > 0) { x.style.top = Math.round(cr.top + cr.height / 2 - (x.offsetHeight || 16) / 2) + 'px'; } }
    if (pm) {
      var dr = drawer.getBoundingClientRect(), pr = pm.getBoundingClientRect();
      var pmCenterInDrawer = (pr.left + pr.right) / 2 - dr.left;
      x.style.right = 'auto';
      x.style.left = Math.round(pmCenterInDrawer - (x.offsetWidth || 16) / 2) + 'px';
    }
  };

  /* --- akordeony linii filtrów --- */
  function openLine(line) {
    var c = line.querySelector('.collapsible'); if (!c) return;
    c.style.maxHeight = c.scrollHeight + 'px';
    setTimeout(function () { if (line.classList.contains('bms-open')) c.style.maxHeight = 'none'; }, 320);
  }
  function closeLine(line) {
    var c = line.querySelector('.collapsible'); if (!c) return;
    c.style.maxHeight = c.scrollHeight + 'px';
    void c.offsetHeight;
    requestAnimationFrame(function () { c.style.maxHeight = '0px'; });
  }
  function lineLabel(line) {
    var s = line.querySelector('h6 .filter-span');
    return s ? s.textContent.trim() : '';
  }
  window.bmsInitFacets = function (openLabels) {
    var scope = scopeEl();
    if (!scope) return;
    scope.querySelectorAll('.filter-line[onclick]').forEach(function (l) { l.removeAttribute('onclick'); });
    scope.querySelectorAll('.collapse-toggle').forEach(function (t) {
      if (t.__bmsBound) return; t.__bmsBound = 1;
      var line = t.closest('.filter-line');
      var c = line ? line.querySelector('.collapsible') : null;
      if (line && c) c.style.maxHeight = line.classList.contains('bms-open') ? 'none' : '0px';
      t.addEventListener('click', function (e) {
        e.stopPropagation(); e.preventDefault();
        if (!line) return;
        var opening = !line.classList.contains('bms-open');
        line.classList.toggle('bms-open');
        if (opening) openLine(line); else closeLine(line);
      }, true);
    });
    if (openLabels && openLabels.length) {
      scope.querySelectorAll('.filter-line').forEach(function (line) {
        var c = line.querySelector('.collapsible'); if (!c) return;
        if (openLabels.indexOf(lineLabel(line)) !== -1) { line.classList.add('bms-open'); c.style.maxHeight = 'none'; }
        else { line.classList.remove('bms-open'); c.style.maxHeight = '0px'; }
      });
    } else if (!scope.querySelector('.filter-line.bms-open')) {
      var first = scope.querySelector('.filter-line');
      var fc = first ? first.querySelector('.collapsible') : null;
      if (first && fc) { first.classList.add('bms-open'); fc.style.maxHeight = 'none'; }
    }
  };

  /* --- AJAX: odświeżanie wyników bez zamykania panelu --- */
  var bmsBusy = false;
  function buildUrl(form) {
    var params = new URLSearchParams();
    var fd = new FormData(form);
    fd.forEach(function (v, k) { if (v !== '' && v != null) params.append(k, v); });
    var cur = new URLSearchParams(location.search);
    if (cur.get('q') && !params.get('q')) params.set('q', cur.get('q'));
    if (cur.get('sort_by') && !params.get('sort_by')) params.set('sort_by', cur.get('sort_by'));
    var qs = params.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }
  function refreshResults() {
    var scope = scopeEl();
    var form = scope && scope.querySelector('form');
    if (!form || bmsBusy) return;
    bmsBusy = true;
    scope.classList.add('bms-facets-loading');
    var url = buildUrl(form);
    fetch(url, { headers: { 'Accept': 'text/html' } }).then(function (r) { return r.text(); }).then(function (txt) {
      var doc = new DOMParser().parseFromString(txt, 'text/html');
      var pairs = [
        ['#search-results', '#search-results'],
        ['.collection-grid-section', '.collection-grid-section'],
        ['.bms-search-count', '.bms-search-count']
      ];
      pairs.forEach(function (p) {
        var tgt = document.querySelector(p[0]);
        var src = doc.querySelector(p[1]);
        if (tgt && src) tgt.innerHTML = src.innerHTML;
      });
      var nf = doc.querySelector('.bms-search-facets form');
      if (nf) {
        var open = [].map.call(scope.querySelectorAll('.filter-line.bms-open'), lineLabel);
        var st = scope.scrollTop;
        form.innerHTML = nf.innerHTML;
        form.querySelectorAll('.collapse-toggle').forEach(function (t) { t.__bmsBound = 0; });
        window.bmsInitFacets(open);
        scope.scrollTop = st;
      }
      history.replaceState({}, '', url);
      bmsBusy = false;
      scope.classList.remove('bms-facets-loading');
    }).catch(function () {
      bmsBusy = false;
      scope.classList.remove('bms-facets-loading');
      location.href = url;
    });
  }
  function initAjax() {
    var scope = scopeEl();
    var form = scope && scope.querySelector('form');
    if (!form || form.__bmsAjax) return;
    form.__bmsAjax = 1;
    /* BELLER 21.09.2026: na duzym ekranie wyniki odswiezaja sie od razu,
       na telefonie czekaja na „Pokaz wyniki".
       Na telefonie kazde zaznaczenie przebudowywalo caly panel, co przy suwaku ceny
       wyrywalo uchwyt spod palca. Na komputerze tego problemu nie ma, a czekanie na
       przycisk tylko spowalnia. Granica 900 px to ta sama, przy ktorej panel przestaje
       byc szuflada. */
    form.addEventListener('change', function (e) {
      if (window.matchMedia('(max-width: 900px)').matches) return;
      var t = e.target;
      if (t && t.matches('input[type="checkbox"], input[type="number"]')) refreshResults();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      refreshResults();
      /* „Pokaż": w trybie drawera zamykamy panel, żeby od razu widać było wyniki */
      document.body.classList.remove('bms-facets-open');
    });
  }

  /* --- sortowanie: zamykanie po kliknięciu obok --- */
  function initSortClose() {
    document.addEventListener('click', function (e) {
      var s = document.querySelector('.bms-search-sort');
      if (s && !s.contains(e.target)) s.classList.remove('open');
    });
  }

  /* --- wyszukiwanie: odstęp pod headerem --- */
  function fixHeaderClearance() {
    /* BELLER 21.09.2026: odstep pod naglowkiem dotyczy TRESCI STRONY /search.
       Poprzednio brane bylo pierwsze `.main-search` w dokumencie, a na kazdej
       stronie poza wyszukiwaniem pierwsza jest szuflada wyszukiwarki w naglowku.
       Szuflada dostawala przez to 113 px pustego pola i otwierala sie jako bialy
       pas z samym krzyzykiem i lupa. Pomijamy wiec wszystko, co lezy w szufladzie. */
    var kandydaci = document.querySelectorAll('.main-search');
    var m = null;
    for (var i = 0; i < kandydaci.length; i++) {
      if (!kandydaci[i].closest('.topbar')) { m = kandydaci[i]; break; }
    }
    if (!m) return;
    var h = document.querySelector('#header-sections') || document.querySelector('.header');
    if (h) { m.style.paddingTop = (h.offsetHeight + 16) + 'px'; }
  }

  /* pasek FILTRY w kolekcjach: marginesy równe krawędzi zdjęć produktów (mobile: 16px jak tekst) */
  function alignCollectionToolbar() {
    var tb = document.querySelector('.bms-collection-toolbar');
    if (!tb) return;
    var inset = 16;
    if (!window.matchMedia('(max-width: 767px)').matches) {
      var card = document.querySelector('.section-collection-grid .small-block, .collection-grid-section .small-block');
      if (card) inset = parseFloat(getComputedStyle(card).paddingLeft) || 16;
    }
    tb.style.marginLeft = inset + 'px';
    tb.style.marginRight = inset + 'px';
  }
  window.addEventListener('resize', alignCollectionToolbar);

  /* mobile: tap w pasek wyszukiwania od razu daje fokus (otwiera klawiaturę) */
  document.addEventListener('click', function (e) {
    var box = e.target.closest('.bms-searchbox');
    if (!box || e.target.closest('button, a')) return;
    var inp = box.querySelector('input[type="text"]');
    if (inp && document.activeElement !== inp) { inp.focus(); }
  });

  /* JEDNA GRUPA OTWARTA NARAZ, standard panelu BELLER z 4.09.
     Błażej: „jak rozwine dwa to konczy mi sie strona". Zmierzone: dwanascie grup,
     dwie rozwiniete daja 1099px przy oknie 900px. Nasluch jest delegowany na
     dokumencie, bo panel jest przebudowywany po kazdym odswiezeniu wynikow. */
  var bmsZwijanieWToku = false;
  document.addEventListener('click', function (e) {
    var przelacznik = e.target.closest('.collapse-toggle');
    if (!przelacznik) return;
    var panel = przelacznik.closest('#CollectionFiltersForm, .bms-search-facets');
    if (!panel) return;
    if (bmsZwijanieWToku) return;
    var cel = przelacznik.nextElementSibling;
    /* PULAPKA: klasa „collapsed" ZOSTAJE na elemencie takze wtedy, gdy grupa jest
       otwarta, bo motyw animuje wysokosc zamiast przelaczac klase. Stan czytamy
       wiec z wysokosci, nie z klasy. Czekamy 60 ms, bo animacja trwa. */
    setTimeout(function () {
      if (!cel || cel.getBoundingClientRect().height <= 2) return;
      bmsZwijanieWToku = true;
      panel.querySelectorAll('.collapse-toggle').forEach(function (inny) {
        if (inny === przelacznik) return;
        var celInnego = inny.nextElementSibling;
        if (celInnego && celInnego.getBoundingClientRect().height > 2) inny.click();
      });
      setTimeout(function () { bmsZwijanieWToku = false; }, 0);
    }, 60);
  }, true);

  function initAll() {
    window.bmsInitFacets();
    initAjax();
    alignCollectionToolbar();
    initSortClose();
    fixHeaderClearance();
  }
  window.addEventListener('resize', fixHeaderClearance);
  window.addEventListener('load', function () { fixHeaderClearance(); setTimeout(fixHeaderClearance, 700); window.bmsAlignFacetsClose(); });
  window.addEventListener('resize', function () { window.bmsAlignFacetsClose(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
